import gettext from '@sdk/lang/gettext';
import { PAYMENT_TYPES } from '@sdk/account/constants';

import googlecalImage from '../assets/images/premium-features/googlecal.png';
import shiftAppearanceImage from '../assets/images/premium-features/shift-appearance.png';
import visibilityImage from '../assets/images/premium-features/visibility.png';
import tcPayrollImage from '../assets/images/premium-features/tc-payroll.png';
import budgetingImage from '../assets/images/premium-features/budgeting.png';
import templatesImage from '../assets/images/premium-features/templates.png';
import overtimeImage from '../assets/images/premium-features/overtime.png';
import laborPercentageImage from '../assets/images/premium-features/labor-percentage.png';
import businessClosedImage from '../assets/images/premium-features/business-closed.png';
import availableSlotsImage from '../assets/images/premium-features/slots.png';
import unassignedSlotsImage from '../assets/images/premium-features/unassigned-slots.png';
import smsAlarmsImage from '../assets/images/premium-features/sms.png';
import mobileTimeclockImage from '../assets/images/premium-features/mobile-tc.png';
import projectedSalesUploadImage from '../assets/images/premium-features/projected-sales.png';
import projectedSalesEditImage from '../assets/images/premium-features/projected-sales-edits.png';
import noShowImage from '../assets/images/premium-features/noshow.png';
import customRangeImage from '../assets/images/premium-features/custom-range.png';
import holidayPayImage from '../assets/images/premium-features/holiday-pay.png';
import enableMsgImage from '../assets/images/premium-features/messages-requires-premium.png';
import enableNewsfeedImage from '../assets/images/premium-features/enable-newsfeed.png';
import enableTasksImage from '../assets/images/premium-features/enable-tasks.png';
import multipleApplicantsImage from '../assets/images/premium-features/multiple-applicants.png';
import shiftSwapImage from '../assets/images/premium-features/shift-swap.png';
import sickCalloutImage from '../assets/images/premium-features/sick-callout.png';
import newsfeedRestrictionsImage from '../assets/images/premium-features/nf-access-restriction.png';
import salariesImage from '../assets/images/premium-features/salaries-preview.svg';
import dayPartsImage from '../assets/images/premium-features/day-parts.svg';
import lateArrivalImage from '../assets/images/premium-features/late-arrival.png';
import kioskImage from '../assets/images/premium-features/kiosk.png';
import shiftsBulkEditImage from '../assets/images/premium-features/shifts-bulk-edit.svg';
import shiftTemplatesImage from '../assets/images/premium-features/shift-templates.svg';
import multipleAlarmsImage from '../assets/images/premium-features/multiple-alarms.svg';
import unavailabilityApprovalImage from '../assets/images/premium-features/unavailabilityApproval.png';
import usersVisibilityImage from '../assets/images/premium-features/usersVisibility.svg';
import shiftAcceptanceImage from '../assets/images/premium-features/shift-acceptance.png';
import autoAssigningImage from '../assets/images/premium-features/auto-assigning.svg';
import clopeningImage from '../assets/images/premium-features/clopening.png';

export const SLING_FREE = 0;
export const SLING_PREMIUM = 1;
export const SLING_OLD_PREMIUM = 2;
export const SLING_BUSINESS = 3;

/* eslint-disable quote-props */
export const FEATURE_ACCESS = {
  'Shift scheduling': SLING_FREE,
  'Shift templates': SLING_FREE,
  'Shift alarms': SLING_FREE,
  'Shift offers': SLING_FREE,
  'Available shifts': SLING_FREE,
  'Time off requests': SLING_FREE,
  Unavailability: SLING_FREE,
  'Private and group chats': SLING_FREE,
  'News sharing': SLING_FREE,
  'Task management': SLING_FREE,
  'Long term scheduling': SLING_FREE,
  'Unlimited employees': SLING_FREE,
  'Multiple locations': SLING_FREE,
  'Time clock': SLING_PREMIUM,
  'Early clock in prevention': SLING_PREMIUM,
  'Auto clock out': SLING_PREMIUM,
  'Timesheet approvals': SLING_PREMIUM,
  'Shift swaps': SLING_PREMIUM,
  'Slots on available shifts': SLING_PREMIUM,
  'Google Calendar synchronization': SLING_PREMIUM,
  'Day parts': SLING_PREMIUM,
  'PTO tracking': SLING_OLD_PREMIUM,
  'Labor cost': SLING_PREMIUM,
  Overtime: SLING_PREMIUM,
  Budgeting: SLING_PREMIUM,
  'Auto-assigning': SLING_OLD_PREMIUM,
  Reports: SLING_OLD_PREMIUM,
  'No shows': SLING_OLD_PREMIUM,
  Kiosk: SLING_OLD_PREMIUM,
  'Shift tags': SLING_OLD_PREMIUM,
  'SMS shift alarms': SLING_PREMIUM,
  'Sick callouts': SLING_OLD_PREMIUM,
  'Late arrivals': SLING_OLD_PREMIUM,
  'Salary support': SLING_OLD_PREMIUM,
  'Conversation settings': SLING_OLD_PREMIUM,
  'Newsfeed page settings': SLING_OLD_PREMIUM,
  'Dedicated account management': SLING_BUSINESS,
  'Shift tasks': SLING_BUSINESS,
  'Shift acceptance': SLING_BUSINESS,
};
/* eslint-enable quote-props */

export const OTHER_BUSINESS_CATEGORY = 'Other';
export const BUSINESS_CATEGORIES = [
  'Bar',
  'Café',
  'Call center',
  'Catering',
  'Childcare',
  'Cleaning',
  'Coffee shop',
  'Construction',
  'Customer support',
  'Education',
  'Events and entertainment',
  'Fire department',
  'Fitness',
  'Food truck',
  'Government',
  'Healthcare',
  'Home care services',
  'Hotel',
  'Library',
  'Nonprofit',
  'Parks and recreation',
  'Pet care',
  'Restaurant',
  'Retail',
  'Security',
  'Technology',
  'Theater',
  'Transportation',
  'Valet service',
  OTHER_BUSINESS_CATEGORY,
];

export const STABLE_PRICE = 19.9;

export const CANCEL_REASON_SEASONAL = 1;
export const CANCEL_REASON_TOO_EXPENSIVE = 4;
export const CANCEL_REASON_BUSINESS_CLOSING = 7;

export const PREMIUM_CANCEL_REASONS = [
  { id: CANCEL_REASON_SEASONAL, reason: 'Seasonal business' },
  { id: 2, reason: 'Not finding enough value in the paid features', textRequired: true },
  { id: 3, reason: 'Missing essential features', textRequired: true },
  { id: CANCEL_REASON_TOO_EXPENSIVE, reason: 'Too expensive' },
  { id: 5, reason: 'Cancelling Sling account' },
  { id: 6, reason: 'Too confusing', textRequired: true },
  { id: CANCEL_REASON_BUSINESS_CLOSING, reason: 'Our business is closing' },
  { id: 8, reason: 'Other', textRequired: true },
];

export const BUSINESS_DOWNGRADE_REASONS = [
  { id: 1, reason: 'Seasonal business' },
  { id: 2, reason: 'Not finding enough value in the Business features', textRequired: true },
  { id: 3, reason: 'Missing essential features', textRequired: true },
  { id: 4, reason: 'Too expensive' },
  { id: 5, reason: 'Cancelling Sling account' },
  { id: 6, reason: 'Too confusing', textRequired: true },
  { id: 7, reason: 'Our business is closing' },
  { id: 8, reason: 'Other', textRequired: true },
];

export const PREMIUM_FEATURES_INFO = {
  googleCalendarSync: {
    title: 'Google Calendar synchronization',
    description:
      'Sync your Sling schedule to Google Calendar to overlay your work schedule on top of your existing personal calendar.',
    iconUrl: googlecalImage,
  },
  shiftAppearance: {
    title: 'Shift appearance on calendar',
    description:
      'Specify the information that needs to be displayed on the shift blocks to customize the way shifts appear on the schedule.',
    iconUrl: shiftAppearanceImage,
  },
  smsAlarms: {
    title: 'SMS shift alarms',
    description:
      'Enable SMS shift alarms so that your employees can get reminded of their upcoming shifts via SMS. SMS shift alarms can be sent alone or in combination with push and email notifications.',
    iconUrl: smsAlarmsImage,
  },
  clockIn: {
    title: 'Mobile and web time clock',
    description:
      'Turn any phone into time clock and allow employees to clock in and out of their shifts right from their Sling apps. Use in-app time clock alone, or in combination with the time clock kiosk.',
    iconUrl: mobileTimeclockImage,
  },
  payroll: {
    title: 'Time clock and payroll',
    description:
      'Simplify your time-tracking process with the time clock feature on Sling. Easily track employee hours and export timesheets for seamless payroll processing. Cut costs for your business and reduce headaches for managers.',
    iconUrl: tcPayrollImage,
    noMargin: true,
  },
  managerScheduleVisibility: {
    title: 'Visibility of schedules for managers',
    description:
      'For multi-location accounts, streamline each managers view by only showing them employee schedules at the locations they oversee.',
    iconUrl: visibilityImage,
  },
  paidTimeOffs: {
    useReactTemplate: true,
  },
  laborCost: {
    useReactTemplate: true,
  },
  laborPercentage: {
    title: 'Labor %',
    description:
      'View labor as a percentage of sales to get an accurate sense of your labor costs and ensure your budgets are met consistently. Set your Labor % target and monitor how each shift you schedule affects that number.',
    iconUrl: laborPercentageImage,
    noMargin: true,
  },
  budget: {
    title: 'Budgeting',
    description:
      'Keep track of your labor budget to produce a substantial amount of savings. Set how much you want to spend on labor or how many hours you want to schedule per week per location. Get notified whenever you are about to hit the limit and adjust your schedules accordingly.',
    iconUrl: budgetingImage,
  },
  templates: {
    title: 'Schedule templates',
    description:
      'Schedule faster by saving schedules into templates for future use. Load an appropriate template, when applicable, to recreate the schedule in just a few clicks.',
    iconUrl: templatesImage,
    noMargin: true,
  },
  overtime: {
    title: 'Overtime',
    description:
      'Spot and avoid potential overtime cases before they become a problem. Get notified and make changes whenever you are about to schedule someone into overtime, and easily check how much they are costing your business.',
    iconUrl: overtimeImage,
  },
  businessClosed: {
    title: 'Business closed',
    description:
      'Mark days as closed right from the shifts calendar to avoid scheduling employees or approving their time off requests when no one is working.',
    iconUrl: businessClosedImage,
  },
  availableSlots: {
    title: 'Available shifts slots',
    description:
      "Specify the number of employees required for each of the available shifts to set your schedule targets and get your coverage right. As employees apply, you'll see the total number of slots reduced to reflect the number of people still needed.",
    iconUrl: availableSlotsImage,
  },
  unassignedSlots: {
    title: 'Unassigned shifts slots',
    description:
      "Specify the number of employees required for each unassigned shift to set your schedule targets and get your coverage right. As you assign these shifts, you'll see the total number of slots reduced to reflect the number of people still needed.",
    iconUrl: unassignedSlotsImage,
    imageScale: 1,
  },
  projectedSalesEdit: {
    title: 'Projected sales edit',
    description:
      'Update projected sales manually right from the calendar to make them match your actual sales and get an accurate sense of your labor %.',
    iconUrl: projectedSalesEditImage,
    noMargin: true,
  },
  projectedSalesUpload: {
    title: 'Projected sales upload',
    description:
      'Upload projected sales from a file to calculate your labor % and get an accurate sense of your labor cost. You can still edit your sales manually afterwards, right from the calendar.',
    iconUrl: projectedSalesUploadImage,
  },
  projectedSalesBudget: {
    title: 'Projected sales',
    description:
      'Set sales defaults for each day of the week or upload projected sales from a file to calculate your labor % and get an accurate sense of your labor cost. You can still edit your sales manually afterwards, right from the calendar.',
    iconUrl: budgetingImage,
  },
  noShow: {
    title: 'No shows',
    description:
      'Mark a shift employee has missed as no show to preserve a history of attendance and create a copy of the shift to find a replacement.',
    iconUrl: noShowImage,
  },
  sickCallout: {
    title: 'Sick callouts',
    description:
      'Mark a shift employee has missed as sick callout to keep a history of attendance and track PTO, and create a copy of the shift to find a replacement.',
    iconUrl: sickCalloutImage,
  },
  customRange: {
    title: 'Custom range',
    description:
      'Set a custom date range on the schedule to Increase viewing flexibility. Choose a start and end date rather than being restricted to viewing a day, week, or month at a time.',
    iconUrl: customRangeImage,
  },
  holidayPay: {
    title: 'Holiday pay',
    description:
      'Set a holiday pay rate and customize which days have this special pay. Streamline accounting and make sure your employees are compensated fairly for any holidays worked.',
    iconUrl: holidayPayImage,
  },
  messages: {
    useReactTemplate: true,
  },
  enableMessages: {
    title: 'Messages',
    description:
      "Add more control over what your organization can access by disabling the Messages feature. If messaging isn't needed for your organization, hide it to have a simpler view and to prevent misuse.",
    iconUrl: enableMsgImage,
  },
  enableNewsfeed: {
    title: 'Enable newsfeed feature',
    description:
      "Add more control over what your organization can access by disabling the Newsfeed feature. If Newsfeed isn't needed for your organization, hide it to have a simpler view and to prevent misuse.",
    iconUrl: enableNewsfeedImage,
  },
  enableTasks: {
    title: 'Enable tasks feature',
    description:
      "Add more control over what your organization can access by disabling the Tasks feature. If Tasks aren't needed for your organization, hide them to have a simpler view and to prevent misuse.",
    iconUrl: enableTasksImage,
  },
  multipleApplicants: {
    title: 'Multiple applicants',
    description:
      'Increase efficiency by approving multiple shift applicants at once. Select as many people as needed to meet staffing needs for the shift.',
    iconUrl: multipleApplicantsImage,
  },
  tags: {
    useReactTemplate: true,
  },
  shiftSwap: {
    title: 'Shift swap',
    description:
      'Allow employees to exchange shifts, and track both the shifts they offer and the shifts they pick up in one process. Get alerted of any overtime these exchanges might cause.',
    iconUrl: shiftSwapImage,
  },
  conversationRestrictions: {
    useReactTemplate: true,
  },
  newsfeedRestrictions: {
    title: 'Access restrictions',
    description:
      'Decide who should be able to create new pages on Sling with this setting. Prevent duplicate pages and information overload.',
    iconUrl: newsfeedRestrictionsImage,
    noMargin: true,
  },
  salaries: {
    title: 'Salary support',
    description:
      'Specify annual salary for your salaried employees, so their costs are properly accounted for in schedules and reports.',
    iconUrl: salariesImage,
    noMargin: true,
    imageScale: 1,
  },
  dayParts: {
    title: 'Day Parts',
    description:
      'Use day parts to separate shifts according to the time of day when they occur. These can be used to filter and sort your shifts on the schedule.',
    iconUrl: dayPartsImage,
    imageScale: 1,
  },
  lateArrival: {
    title: 'Late arrival',
    description:
      'Set rules for tracking late arrivals and let Sling keep a record. Quickly spot your employees’ attendance habits, and recognize their tardiness before it becomes the norm.',
    iconUrl: lateArrivalImage,
    noMargin: true,
    imageScale: 1,
  },
  kiosk: {
    title: 'Time clock kiosk',
    description:
      'Set up time clock kiosk on the device you wish to use as a terminal for your employees to clock in and out of their shifts. Use the on-site time clock alone, or in combination with mobile and web time clock.',
    iconUrl: kioskImage,
    noMargin: true,
    imageScale: 1,
  },
  shiftsBulkEdit: {
    title: 'Bulk Edit',
    description:
      'Need to make lots of changes fast? Our bulk edit feature lets you change multiple shifts at the same time in just a few clicks.',
    imageScale: 1,
    iconUrl: shiftsBulkEditImage,
  },
  shiftTemplates: {
    title: 'Shift templates',
    description:
      'Schedule faster with shift templates. Just drag and drop a template to the schedule or apply one when creating a new shift. ',
    imageScale: 1,
    noMargin: true,
    iconUrl: shiftTemplatesImage,
  },
  multipleAlarms: {
    title: 'Multiple alarms',
    description:
      'Allow your employees to set multiple shift alarms to make sure they are never late for their shifts',
    imageScale: 1,
    iconUrl: multipleAlarmsImage,
  },
  shiftTasks: {
    useReactTemplate: true,
  },
  unavailability: {
    useReactTemplate: true,
  },
  unavailabilityApproval: {
    title: 'Unavailability approval',
    description:
      'Review potential changes to your employees unavailability to avoid any last-minute changes and manage your staffing.',
    iconUrl: unavailabilityApprovalImage,
    noMargin: true,
  },
  usersCanSeeUsersOutsideLocation: {
    title: 'Visibility of coworkers across locations',
    description:
      'For multi-location accounts, allow employees to view and communicate with coworkers assigned to different locations.',
    iconUrl: usersVisibilityImage,
    imageScale: 1,
  },
  shiftAcceptance: {
    title: 'Shift acceptance',
    description:
      'Make sure your employees have seen their work schedule and acknowledge their shifts.',
    iconUrl: shiftAcceptanceImage,
  },
  autoAssigning: {
    title: gettext('Auto-assign shifts'),
    description: gettext(
      'Allocate unassigned shifts to available employees with compatible locations and positions at a click of a button.'
    ),
    iconUrl: autoAssigningImage,
    imageScale: 1,
    noMargin: true,
  },
  clopening: {
    title: gettext('Clopening'),
    description: gettext(
      'Avoid clopening shifts by specifying the minimum number of rest hours between the closing and opening shifts.'
    ),
    iconUrl: clopeningImage,
    imageScale: 1,
  },
  reports: {
    useReactTemplate: true,
  },
  iCalendarSync: {
    useReactTemplate: true,
  },
  userDocuments: {
    useReactTemplate: true,
  },
  laborCompliance: {
    useReactTemplate: true,
  },
  breaksAttestation: {
    useReactTemplate: true,
  },
  automatedBreaks: {
    useReactTemplate: true,
  },
  bulkMessages: {
    useReactTemplate: true,
  },
  groupMessages: {
    useReactTemplate: true,
  },
  shiftFeedback: {
    useReactTemplate: true,
  },
  freeUserLimit: {
    useReactTemplate: true,
  }
};

export const SUBSCRIPTION_LEVELS = {
  FREE: 0,
  PREMIUM: 1,
  OLD_PREMIUM: 2,
  BUSINESS: 3,
};

export const SUBSCRIPTION_TRIAL_CYCLICAL_REACTIVATION_DAYS = 180;
export const SUBSCRIPTION_TRIAL_FIRST_REACTIVATION_DAYS = 100;

export const EXCLUSIVE_PAYMENT_TYPES = {
  [PAYMENT_TYPES.SHOPIFY_BILLING]: {
    label: 'Shopify Billing',
    value: PAYMENT_TYPES.SHOPIFY_BILLING,
  },
};

export const PAYMENT_TYPES_OPTIONS = [
  {
    label: 'Credit card',
    value: PAYMENT_TYPES.CREDIT_CARD,
  },
  {
    label: 'ACH Credit Transfer',
    value: PAYMENT_TYPES.ACH_CREDIT_TRANSFER,
  },
];

export const ACH_STATUS = {
  PENDING: 'pending',
  CHARGEABLE: 'chargeable',
};

export const AUTO_ASSIGNING_MODAL_MODES = {
  HAS_ACCESS: 'has-access',
  LAUNCH_TRIAL: 'launch-trial',
  AFTER_TRIAL: 'after-trial',
};
